import { FormInstance } from "antd";
import { isVTUserIdTaken } from "api/services/ContactService";
import { RegisterUserType, TVTUser } from "api/services/models/types";

const REGEX_LOWER_CASE = /[a-z]+/;
const REGEX_UPPER_CASE = /[A-Z]+/;
const REGEX_DIGI_CASE = /\d+/;
const REGEX_SPECIAL_CHARCTERS = /[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]+/;

export const validatePassword = (userType: RegisterUserType) => ({
  validator: (_: any, value: string, callback: (msg?: string) => void) => {
    if (userType !== RegisterUserType.IntenalUser) callback();
    if (value && value.length > 0 && (value.length < 8 || value.length > 25))
      return callback("Password must be between 8-25 characters");

    let countPasswordClass = 0;
    if (REGEX_LOWER_CASE.test(value)) countPasswordClass++;
    if (REGEX_UPPER_CASE.test(value)) countPasswordClass++;
    if (REGEX_DIGI_CASE.test(value)) countPasswordClass++;
    if (REGEX_SPECIAL_CHARCTERS.test(value)) countPasswordClass++;

    if (countPasswordClass < 4)
      return callback(
        "password needs to be a mix of uppercase, lowercase letters, numbers, and symbols"
      );
    callback();
  }
});

export const validateVTUserId = (vtUser?: TVTUser | null) => {
  return ({ getFieldValue }: { getFieldValue: FormInstance["getFieldValue"] }) => ({
    validator(_: any, value: string, callback: (msg?: string) => void) {
      const dialedNumber = getFieldValue("dialedNumber");
      const userId = getFieldValue("userId") as string;
      if (
        (vtUser == null || dialedNumber != vtUser?.dialedNumber) &&
        userId &&
        userId.length >= 3 &&
        userId.length <= 8
      ) {
        if (Number(userId)) {
          isVTUserIdTaken(userId, dialedNumber).then(t => (t ? callback("Taken") : callback()));
        } else {
          callback("Invalid");
        }
      } else {
        callback();
      }
    }
  });
};
